import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import { api_url } from "../config/config";
// import "react-toastify/dist/ReactToastify.css";

// Initialize Toastify
// toast.configure();

function SubcategoryManagement() {
    const [categories, setCategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [formData, setFormData] = useState({
        subCategories: "",
        image: null,
        category_id: "",
    });
    const [editingSubcategoryId, setEditingSubcategoryId] = useState(null);
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        // Fetch categories
        axios
            .get(`${api_url}/categories`)
            .then((response) => {
                if (!response.data.error) {
                    setCategories(response.data.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching categories:", err);
            });

        // Fetch subcategories
        axios
            .get(`${api_url}/subcategory`)
            .then((response) => {
                if (!response.data.error) {
                    setSubcategories(response.data.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching subcategories:", err);
            });
    }, [trigger]);

    // Handle Input Changes
    const handleInputChange = (e) => {
        const { value } = e.target;
        const subCategories = value.split(",").map((name) => name.trim());
        setFormData({ ...formData, subCategories });
    };

    const handleCategoryChange = (e) => {
        setFormData({ ...formData, category_id: e.target.value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, image: file });
    };

    // Form Validation
    const isFormValid = () => {
        if (
            !formData.subCategories ||
            !formData.image ||
            !formData.category_id
        ) {
            toast.error("All fields are mandatory!");
            return false;
        }
        return true;
    };

    // Handle Create
    const handleCreateSubcategory = () => {
        if (!isFormValid()) return;

        const formDataWithImage = new FormData();
        formDataWithImage.append("category_id", formData.category_id);
        formDataWithImage.append("files", formData.image);
        formDataWithImage.append(
            `subCategories`,
            JSON.stringify(formData.subCategories)
        );

        axios
            .post(`${api_url}/subcategory`, formDataWithImage)
            .then((response) => {
                if (!response.data.error) {
                    setTrigger(!trigger);
                    setFormData({
                        subCategories: "",
                        image: null,
                        category_id: "",
                    })
                    toast.success("Subcategory created successfully!",);
                }
            })
            .catch((err) => {
                console.error("Error creating subcategories:", err);
            });
    };

    // Handle Delete
    const handleDeleteSubcategory = (subcategoryId) => {
        axios
            .delete(`${api_url}/subcategory/${subcategoryId}`)
            .then(() => {
                setTrigger(!trigger);
                toast.success("Subcategory deleted successfully!");
            })
            .catch((err) => {
                console.error("Error deleting subcategory:", err);
            });
    };

    return (
        <div className="max-w-6xl mx-auto p-6 bg-gray-100 rounded-lg ">
            <ToastContainer />
            <h2 className="text-3xl font-bold text-gray-700 mb-6">
                Subcategory Management
            </h2>

            {/* Form Section */}
            <div className="flex flex-col space-y-4 bg-white p-6 rounded-lg ">
                <input
                    type="text"
                    placeholder="Enter subcategory names"
                    onChange={handleInputChange}
                    className="p-3 border rounded-md focus:ring focus:ring-blue-200"
                />
                <input
                    type="file"
                    onChange={handleImageChange}
                    className="p-3 border rounded-md focus:ring focus:ring-blue-200"
                />
                <select
                    onChange={handleCategoryChange}
                    value={formData.category_id}
                    className="p-3 border rounded-md focus:ring focus:ring-blue-200"
                >
                    <option value="">Select a Category</option>
                    {categories.map((category) => (
                        <option
                            key={category.category_id}
                            value={category.category_id}
                        >
                            {category.name}
                        </option>
                    ))}
                </select>

                {/* Action Button */}
                <button
                    onClick={handleCreateSubcategory}
                    className="bg-green-500 hover:bg-green-600 text-white font-semibold w-[400px] p-3 rounded-lg"
                >
                    {editingSubcategoryId ? "Update Subcategory" : "Create Subcategory"}
                </button>
            </div>

            {/* Subcategories List */}
            <div className="mt-8 flex flex-wrap gap-5 ">
                {subcategories.map((subcategory) => (
                    <div
                        key={subcategory.id}
                        className="flex justify-between items-center w-[500px]  bg-white p-4 rounded-lg  mb-4"
                    >
                        <div className="flex items-center  space-x-4">
                            <img
                                src={subcategory.image}
                                alt={subcategory.name}
                                className="w-16 h-16 rounded-md object-cover"
                            />
                            <h3 className="text-lg font-semibold text-gray-700">
                                {subcategory.name}
                            </h3>
                        </div>
                        <button
                            onClick={() =>
                                handleDeleteSubcategory(subcategory.subcategory_id)
                            }
                            className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-md"
                        >
                            Delete
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SubcategoryManagement;
